import ro from 'date-fns/esm/locale/ro';
import en from 'date-fns/esm/locale/en-US/';
import de from 'date-fns/esm/locale/de';
import nl from 'date-fns/esm/locale/nl';
import fr from 'date-fns/esm/locale/fr';
import pt from 'date-fns/esm/locale/pt';
import ar from 'date-fns/esm/locale/ar';

const i18n = {
    ro, en, de, nl, fr, br: pt, ar, mn: en, hu: en,
};

export default i18n;



// WEBPACK FOOTER //
// ./resources/js/modules/enso/plugins/date-fns/i18n.js